import * as _ from 'lodash';
import { SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, take, toArray } from 'rxjs/operators';

export function ofType<EventType, T = any>(eventType: EventType) {
    return filter(({ type }: Event<EventType, T>) => type === eventType);
}

export function ofTypes<EventType, T = any>(eventTypes: EventType[]) {
    return filter(({ type }: Event<EventType, T>) => eventTypes.includes(type));
}

export function takeValues<T = any>(observable: Observable<T>, count = 1): Promise<T[]> {
    return observable.pipe(take(count), toArray()).toPromise();
}

export interface Event<Type, T = any> {
    type: Type;
    payload?: T;
}

export function AutoUnsubscribe(constructor) {
    const original = constructor.prototype.ngOnDestroy;

    constructor.prototype.ngOnDestroy = function () {
        for (const propertyName in this) {
            const property = this[propertyName];
            if (property && typeof property.unsubscribe === 'function') {
                property.unsubscribe();
            }
        }
        if (original && typeof original === 'function') {
            original.apply(this, arguments);
        }
    };
}

export const withChanges = (propertyName: string) =>
    filter((changes: SimpleChanges) => !!_.get(changes, `${propertyName}.currentValue`));
export const takeChanges = <T>(propertyName: string) =>
    map((changes: SimpleChanges) => _.get(changes, `${propertyName}.currentValue`) as unknown as T);
export const takeOnlyNewChanges =
    <T>(propertyName: string) =>
    (changes: Observable<SimpleChanges>) =>
        changes.pipe(withChanges(propertyName), takeChanges<T>(propertyName));
